import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "icon-card-password",
  "use": "icon-card-password-usage",
  "viewBox": "0 0 1228 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1228 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-card-password\"><defs><style type=\"text/css\"></style></defs><path d=\"M0 277.248v577.6384c0 86.8864 78.848 157.5424 175.872 157.5424h848.7936c96.9216 0 175.8208-70.656 175.8208-157.5424V277.248H0z m1200.4864-91.1872v-27.136c0-86.8864-78.8992-157.5936-175.8208-157.5936H175.872C78.848 1.3312 0 71.9872 0 158.9248v27.136h1200.4864z m-301.3632 383.6416A179.3536 179.3536 0 0 1 1126.4 742.4a179.2 179.2 0 1 1-337.2032-84.6336l-137.216-154.368-1.1776-103.7824 97.1776 2.2528 1.4848 77.3632 70.4512 3.6864-2.3552 76.032 71.936 0.512 9.6256 10.24zM947.2 819.2a76.8 76.8 0 1 0 0-153.6 76.8 76.8 0 0 0 0 153.6z\" p-id=\"13414\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/svg/card-password.svg
// module id = 6xTX
// module chunks = 7